import React from "react";
import "./Content_Component.css";
import Common_Title_2 from "../../common/common_components/common_title_2/Common_Title_2";
import Info_Card from "../../common/common_components/info_card/Info_Card";

const Content_Component = ({data}) => {
  

  return (
    <section className="Content_Component">
      <div className="content_div">
        <div className="container">
          <div className="inner_content_div">
            <p className="info_text">
             {data?.subname}
            </p>

            <Info_Card title={"Core Principles:"} data={data?.content} />
          </div>
        </div>
      </div>

      <div className="container">
        <div className="inner_content_div">
          <Info_Card title={"Techniques:"} data={data?.techniques} />
          <Info_Card title={"Benefits:"} data={data?.benefits} />
        </div>
      </div>
    </section>
  );
};

export default Content_Component;
